// Enum-like constants. Each is a frozen object plus a string-union type of the
// same name, so values serialize as plain strings (JSON, Postgres ENUM, sockets).

export const Faction = {
  SEPARATIST: 'SEPARATIST',
  FEDERALIST: 'FEDERALIST',
} as const;
export type Faction = (typeof Faction)[keyof typeof Faction];

export const SpecialRole = {
  NENSHI: 'NENSHI',
} as const;
export type SpecialRole = (typeof SpecialRole)[keyof typeof SpecialRole];

export const PolicyFaction = {
  SEPARATION: 'SEPARATION',
  FEDERALIST: 'FEDERALIST',
} as const;
export type PolicyFaction = (typeof PolicyFaction)[keyof typeof PolicyFaction];

/** Alias used by state payloads (spec §68). */
export type PolicyType = PolicyFaction;

export const GamePhase = {
  LOBBY: 'LOBBY',
  ROLE_REVEAL: 'ROLE_REVEAL',
  NOMINATE_PREMIER: 'NOMINATE_PREMIER',
  CONFIDENCE_VOTE: 'CONFIDENCE_VOTE',
  VOTE_RESULT: 'VOTE_RESULT',
  MINISTER_POLICY: 'MINISTER_POLICY',
  PREMIER_POLICY: 'PREMIER_POLICY',
  VETO_RESPONSE: 'VETO_RESPONSE',
  POLICY_RESULT: 'POLICY_RESULT',
  /** Minister and Premier state (truthfully or not) what they saw. */
  SPEECH_FROM_THRONE: 'SPEECH_FROM_THRONE',
  EXECUTIVE_POWER: 'EXECUTIVE_POWER',
  /** Timed open debate at the end of every round. */
  QUESTION_PERIOD: 'QUESTION_PERIOD',
  GAME_OVER: 'GAME_OVER',
} as const;
export type GamePhase = (typeof GamePhase)[keyof typeof GamePhase];

export const GameStatus = {
  LOBBY: 'LOBBY',
  ACTIVE: 'ACTIVE',
  FINISHED: 'FINISHED',
} as const;
export type GameStatus = (typeof GameStatus)[keyof typeof GameStatus];

export const WinReason = {
  SEPARATION_POLICIES: 'SEPARATION_POLICIES',
  FEDERALIST_POLICIES: 'FEDERALIST_POLICIES',
  NENSHI_BECOMES_PREMIER: 'NENSHI_BECOMES_PREMIER',
  NENSHI_REMOVED: 'NENSHI_REMOVED',
} as const;
export type WinReason = (typeof WinReason)[keyof typeof WinReason];

export const ExecutivePower = {
  NONE: 'NONE',
  CAMPAIGN_RESEARCH: 'CAMPAIGN_RESEARCH',
  INTERNAL_POLLING: 'INTERNAL_POLLING',
  UNITY_GOVERNMENT: 'UNITY_GOVERNMENT',
  COURT_CHALLENGE: 'COURT_CHALLENGE',
  COURT_CHALLENGE_AND_VETO: 'COURT_CHALLENGE_AND_VETO',
  FEDERALIST_VICTORY: 'FEDERALIST_VICTORY',
} as const;
export type ExecutivePower = (typeof ExecutivePower)[keyof typeof ExecutivePower];

export const Vote = {
  CONFIDENCE: 'CONFIDENCE',
  NO_CONFIDENCE: 'NO_CONFIDENCE',
} as const;
export type Vote = (typeof Vote)[keyof typeof Vote];

export const VerificationStatus = {
  VERIFIED: 'VERIFIED',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
} as const;
export type VerificationStatus = (typeof VerificationStatus)[keyof typeof VerificationStatus];

/** How a policy reached the track. */
export const EnactmentSource = {
  GOVERNMENT: 'GOVERNMENT',
  GRIDLOCK: 'GRIDLOCK',
} as const;
export type EnactmentSource = (typeof EnactmentSource)[keyof typeof EnactmentSource];
